




















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, PropSync } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { ContentItemGetContentUseCase } from '@/modules/content-item/use-cases/panel/content-item-get-content.use-case'
import PanelContentItemShowContentModal
  from '@/modules/content-item/components/panel/PanelContentItemShowContentModal.vue'

@Component({
  inheritAttrs: false,
  components: { PanelContentItemShowContentModal, BaseButton }
})
export default class PanelContentItemShowContentButton extends Vue {
  constructor(
    private readonly getContentUseCase: ContentItemGetContentUseCase
  ) {
    super()
  }

  @Prop() contentItemId !: number
  @PropSync('closeModal', { default: true }) closeCurrentModal!: boolean

  openPreview() {
    this.getContentUseCase.execute(this.contentItemId)
      .then(value => {
        this.closeCurrentModal = false
        this.$q.dialog({
          component: PanelContentItemShowContentModal,
          contentItem: this.getContentUseCase.item,
          label: 'پیش نمایش'
        })
      })
  }
}
